/** Applies thead text as data-label on tbody cells for mobile card tables. */

export function applyMobileTableLabels(root: ParentNode = document): void {
  const tables = root.querySelectorAll('table');
  tables.forEach((table) => {
    if (table.classList.contains('table-keep-scroll')) {
      return;
    }

    const headers = Array.from(table.querySelectorAll('thead th')).map((th) =>
      (th.textContent || '').replace(/\s+/g, ' ').trim()
    );

    if (!headers.length) {
      return;
    }

    table.querySelectorAll('tbody tr').forEach((tr) => {
      const cells = Array.from(tr.children).filter(
        (el): el is HTMLTableCellElement => el.tagName === 'TD'
      );

      cells.forEach((td, index) => {
        if (td.hasAttribute('colspan')) {
          td.removeAttribute('data-label');
          return;
        }

        const label = headers[index] || '';
        if (label) {
          td.setAttribute('data-label', label);
        }
      });
    });
  });
}

export function watchMobileTableLabels(): () => void {
  let scheduled = false;

  const run = () => {
    scheduled = false;
    applyMobileTableLabels();
  };

  const schedule = () => {
    if (scheduled) {
      return;
    }
    scheduled = true;
    requestAnimationFrame(run);
  };

  applyMobileTableLabels();

  const observer = new MutationObserver(schedule);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  return () => observer.disconnect();
}
